import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ApiDocsPage } from '@/features/api-docs/api-docs-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Documentation interactive de l'API (D3, 2026-10-27) : menu utilisateur et palette ⌘K, groupe « Aide ». */
export const Route = createFileRoute('/$tenant/api-docs')({ component: ApiDocsRoute });

function ApiDocsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} crumbs={[{ label: t('apiDocs.title') }]}>
      <ApiDocsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
